<template>
  <div class="preview">
    <PreviewBar :expire="previewStore.expirationDate" />
    <slot v-if="isInitializedApp" />
    <loading :loaded="rootStore.isContentLoaded" />
  </div>
</template>

<script setup>
import PreviewBar from '@/components/PreviewBar.vue'
import { useStore } from '@/stores/index'
import { usePreviewStore } from '@/stores/preview'

const rootStore = useStore()
const previewStore = usePreviewStore()
const isInitializedApp = ref(false)

// FETCH
try {
  await rootStore.initializeApp()
} catch(err) {
  throw showError({ data: err.data, statusCode: err.statusCode, fatal: true })
} finally {
  isInitializedApp.value = true
}
</script>

<style lang="scss" scoped>
.preview {
  display: block;
}
</style>
